import React from "react";
import topImg from "../../../assets/images/QYQW/top-img.jpg";
import back from "../../../assets/images/QYQW/back.png";
import { useNavigate, useLocation } from "react-router-dom";
import "./style.scss";

export default function QyqwHeader({ title, to }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const pathnameArr = pathname.split("/");

  return (
    <div className="qyqw-header">
      <img src={topImg} className="top-img" alt="topimg" />
      <img
        src={back}
        className="back-img"
        alt="backimg"
        onClick={() => {
          if (pathnameArr.length > 3) navigate(-1);
          else navigate("/GQKP");
        }}
      />
      {/* <div className="top-header">
        <img
          src={back}
          className="back-img"
          alt="backimg"
          onClick={() => {
            if (pathnameArr.length > 3) navigate(-1);
            else navigate("/GQKP");
          }}
        />
        {title}
      </div> */}
    </div>
  );
}
